<template>
  <div>
    <UserNavigation/>
    <CartInfo/>

    <div v-if="isFetchingItems" class="container text-center" style="padding: 30px">
      <b-spinner label="Loading..." variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
    </div>

    <div v-else-if="items.length > 0" class="container">
      <div class="row">
        <ShopItem v-for="item in items"
                  :key="item.id"
                  :item="item"
                  class="col-sm-3"
        />
      </div>

      <div class="page-info-row">
        <button :disabled="pageInfo.isFirstPage"
                type="button"
                class="page-info-button"
                @click="previousPage"
        >&#8249;</button>

        <p v-if="pageInfo.totalElements === 0">0 od 0</p>
        <p v-else>
          {{ pageInfo.currentPage * pageSize + 1 }} -
          {{ Math.min((pageInfo.currentPage + 1) * pageSize, pageInfo.totalElements) }}
          od {{ pageInfo.totalElements }}
        </p>

        <button :disabled="pageInfo.isLastPage"
                type="button"
                class="page-info-button"
                @click="nextPage"
        >&#8250;</button>
      </div>
    </div>

    <div v-else class="container" style="padding: 10px">
      <div class="row">
        <h5>Trenutno nema proizvoda</h5>
      </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import UserNavigation from '../../UserNavigation'
    import ShopItem from './ShopItem'
    import CartInfo from '@/component/user/cart/CartInfo'

    export default {
        name: 'Shop',
        components: {
            UserNavigation,
            ShopItem,
            CartInfo
        },
        data() {
            return {
                page: 0,
                pageSize: 12,
                category: this.$route.params.category.toUpperCase(),
            }
        },
        created() {
            this.pageItemsByCategory({
                page: this.page,
                pageSize: this.pageSize,
                category: this.category
            })
        },
        computed: {
            ...mapGetters([
                'isFetchingItems',
                'getItems',
                'getItemPageInfo'
            ]),

            items: {
                get() {
                    return this.getItems
                }
            },

            pageInfo: {
                get() {
                    return this.getItemPageInfo
                }
            }
        },
        methods: {
            ...mapActions([
                'pageItemsByCategory'
            ]),

            nextPage(e) {
                e.preventDefault()
                this.page += 1
                this.pageItemsByCategory({
                    page: this.page,
                    pageSize: this.pageSize,
                    category: this.category
                })
            },

            previousPage(e) {
                e.preventDefault()
                this.page -= 1
                this.pageItemsByCategory({
                    page: this.page,
                    pageSize: this.pageSize,
                    category: this.category
                })
            }
        }
    }
</script>

<style scoped>
	* {
		background: #F0EAD6;
	}

    .col-sm-3 {
        padding: 15px;
    }

    .page-info-row {
        display: flex;
        align-items: baseline;
        justify-content: center;
        padding: 15px;
    }

    .page-info-button {
        border: none;
        margin-left: 5px;
        margin-right: 5px;
        font-size: 26px;
        font-weight: bold;
        padding: 4px 16px;
        background: transparent;
        vertical-align: middle;
    }

    .page-info-row p {
        font-size: 18px;
    }

    .page-info-button:hover:enabled {
        color: #6f5193;
    }
</style>
